import { route } from 'navi';

const signin = route({
  getTitle: () => 'Sign In',
  getData: (req, ctx) => ({ ctx }),
  getView: async () => import('~/containers/SignIn'),
});

export default signin;
